<template>
  <div v-if="visible" class="app-top-nav" :style="navStyle">
    <div class="app-top-nav__side" @click="onBack">
      <van-icon name="arrow-left" />
    </div>
    <div class="app-top-nav__title"></div>
    <div class="app-top-nav__side" @click="onHome">
      <van-icon name="wap-home-o" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { APP_TOP_NAV_HEIGHT, isAppTopNavVisible } from "@/utils/appTopNav";

export default {
  name: "AppTopNav",

  computed: {
    ...mapState({
      storeTitle: "title",
    }),

    visible() {
      return isAppTopNavVisible(this.$route);
    },

    title() {
      return this.storeTitle || this.$route.meta?.title || "粮巴巴";
    },

    navStyle() {
      return {
        "--app-top-nav-height": `${APP_TOP_NAV_HEIGHT}px`,
      };
    },
  },

  methods: {
    onBack() {
      this.$router.back();
    },

    onHome() {
      this.$router.push("/crm");
    },
  },
};
</script>

<style scoped>
.app-top-nav {
  height: var(--app-top-nav-height);
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
}

.app-top-nav__side {
  width: var(--app-top-nav-height);
  height: var(--app-top-nav-height);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

.app-top-nav__title {
  flex: 1;
  min-width: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
